// eslint-disable-next-line @typescript-eslint/naming-convention
export enum MODALS_SIZE {
  mini = '10px',
  small = '640px',
  smallmedium = '1200px',
  medium = '1080px',
  large = '1440px',
}
